import { z } from "zod";

export const newsLetterForm = z.object({
  email: z.string().trim().email({ message: "Invalid email address" }),
});

export type TNewsLetterForm = z.infer<typeof newsLetterForm>;
